import React, { useState, useEffect } from 'react'
import {
  Row,
  Col,
  Form,
  Input,
  Select,
  Button,
  Table,
  Modal,
  InputNumber,
  Dropdown,
  Menu,
} from 'antd'

import styled from 'styled-components'
import ColorList from 'constants/color.constants'
import {
  LeftOutlined,
  RightOutlined,
  PlusOutlined,
  CloseCircleOutlined,
  EditOutlined,
} from '@ant-design/icons'
import more from 'icons/More.svg'
import { getCookie } from 'helper/cookie'

import {
  getResultKPIFinance,
  addKPIFinance,
  getKpiSearch,
  getKpiType,
  getUnitType,
} from 'api/Project/kpifinance'
import emptyKPI from 'icons/createproject/Subtask.svg'
import { useForm } from 'antd/lib/form/Form'

import FormatNumber from 'common/FormatNumber/money'
import FormatMinMax from 'common/FormatNumber/minmax'
import lang from 'lang/en'
import { ButtonPrimaryOutlineNoBackgroundStyle } from 'common/Button/button.styles'

import ModalMinMax from 'common/KPIFinance/modalMinMax'
import ModalTaskGoals from 'common/KPIFinance/modalTaskGoals'
import ModalAdd from 'common/KPIFinance/modalAddKPI'
import ModalDelete from 'common/KPIFinance/modalDelete'

import NoPermission from 'common/KPIFinance/noPermissionKPI'

import 'styleLess/signature/taskKPIFinance.scss'

const Container = styled.div`
  // background-color: ${ColorList.white};

  // width: 100;
  // height: auto;
  margin-top: 32px;
  // margin-left: 4px;
`
const ConatainerKPI = styled.div``
const SubContainer = styled.div``
const Header = styled.div``
const EmptyState = styled.div``
const Footer = styled.div``
const ContainerCard = styled.div``
const CardItem = styled.div``
const LeftCard = styled.div``
const RightCard = styled.div``

const initalState = {
  data: [],
  isLoading: true,
}
let render = ''
let render2 = ''
const AddTaskKPIFinance = (props) => {
  const {
    swithCaseTaskFLowFunction,
    role,
    idEditPRJ,
    statusProject,
    id,
    canKPIFinance,
  } = props
  const [checkBtn, setCheckBtn] = useState('')
  const [visibleRegister, setVisibleRegister] = useState(true)
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const token = getCookie('access_token_admin')
  const [dataKPIFinance, setDataKPIFinance] = useState()

  const language = getCookie('lang')
  const word = lang[language]
  //Modal
  const [visibleDelete, setVisibleDelete] = useState(false)
  const [visableModal, setVisableModal] = useState(false)
  const [typeBtn, setTypeBtn] = useState(false)
  const [visableModalTaskGoals, setVisableModalTaskGoals] = useState(false)
  const [visableModalMinMax, setVisableModalMinMax] = useState(false)

  //unit type
  const [dataUnitType, setDataUnitType] = useState(initalState.data)

  //add goal project
  const [dataProject, setDataProject] = useState(initalState.data)
  const [dataTask, setDataTask] = useState(initalState.data)
  const [dataDeleteTask, setDataDeleteTask] = useState(initalState.data)
  const [dataEditTask, setDataEditTask] = useState(initalState.data)

  const getKPIFinance = async () => {
    const dataArray = {
      project_id: idEditPRJ,
      sprintflow_id: `${id}`,
    }

    getKpiSearch({
      token: token,
      params: dataArray,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setDataKPIFinance([])
          setDataTask([])
          setIsLoading(false)
          return true
        }
        if (status === 200) {
          setDataKPIFinance(data.projects)
          if (data.projects == '' || data.projects == null) {
            render = ''
          } else {
            render = '1'
          }

          if (data.tasks == '' || data.tasks == null) {
            render2 = ''
          } else {
            render2 = '1'
          }

          setDataTask(data.tasks)
        } else {
          setDataKPIFinance([])
          setDataTask([])
          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataKPIFinance([])
        setDataTask([])
        setIsLoading(false)
        console.error(error)
      })
  }

  useEffect(() => {
    if (token) {
      getKPIFinance()
      render2 = ''
      render = ''
    }
  }, [token])

  const modalDelete = (item) => {
    setVisibleDelete(true)
    setDataDeleteTask(item.id)
  }

  const modalEdit = (item) => {
    setDataEditTask(item)
    onClickShowModal('edit')
  }

  const menu = (item) => {
    return (
      <Menu id="menu">
        <Menu.Item key="0" onClick={() => modalEdit(item)}>
          {word['addtask_kpi_menu_edit']}
        </Menu.Item>
        <Menu.Item key="1" onClick={() => modalDelete(item)}>
          {word['addtask_kpi_menu_delete']}
        </Menu.Item>
      </Menu>
    )
  }

  const showModal = () => {
    return (
      <div>
        <ModalAdd
          visableModal={visableModal}
          setVisableModal={setVisableModal}
          idEditPRJ={idEditPRJ}
          typeBtn={typeBtn}
          getResultKpi={getKPIFinance}
          stateKPI={id}
          dataEdit={dataEditTask}
          titlePage="Task"
        />

        <ModalTaskGoals
          idEditPRJ={idEditPRJ}
          setVisableModalTaskGoals={setVisableModalTaskGoals}
          visableModalTaskGoals={visableModalTaskGoals}
          data={dataProject}
          idtask={id}
          getResultKpi={getKPIFinance}
          type=""
        />

        <ModalMinMax
          idEditPRJ={idEditPRJ}
          setVisableModalMinMax={setVisableModalMinMax}
          visableModalMinMax={visableModalMinMax}
          data={dataProject}
          idtask={id}
          getResultKpi={getKPIFinance}
          type=""
          typeState="task"
        />

        <ModalDelete
          visibleDelete={visibleDelete}
          setVisibleDelete={setVisibleDelete}
          idEditPRJ={idEditPRJ}
          idKPI={dataDeleteTask}
          getResultKpi={getKPIFinance}
          type=""
        />
      </div>
    )
  }

  const onClickShowModal = (type) => {
    setVisableModal(true)
    setTypeBtn(type)
  }

  //check input type
  const checkInputTypeShowmodal = (inputType, item) => {
    if (inputType == 22) {
      setVisableModalMinMax(true)
      setDataProject(item)
    } else {
      setVisableModalTaskGoals(true)
      setDataProject(item)
    }
  }

  const checkShowInputTypeTask = (inputType, item) => {
    if (inputType == 22) {
      // if ((item.sprintflow_min == 0) & (item.sprintflow_max == 0)) {
      //   return (
      //     <div style={{ marginLeft: 0 }}>
      //       <span className="small">{word['addtask_kpi_title_taskgoalminmax']}</span>
      //       <p>-</p>
      //     </div>
      //   )
      // }
      // return (
      //   <div>
      //     <span className="small">{word['addtask_kpi_title_taskgoalminmax']}</span>
      //     <p>
      //       <FormatMinMax num={item.sprintflow_min} /> -{' '}
      //       <FormatMinMax num={item.sprintflow_max} /> {item.unit_type_name}
      //     </p>
      //   </div>
      // )
      return (
        <div>
          <span className="small">{word['addtask_kpi_title_taskgoalminmax']}</span>
          <p>
            <FormatMinMax num={item.sprintflow_min} /> -{' '}
            <FormatMinMax num={item.sprintflow_max} /> {item.unit_type_name}
          </p>
        </div>
      )
    } else {
      // if (item.sprintflow_goal == 0) {
      //   return (
      //     <div>
      //       <span className="small">{word['addtask_kpi_title_taskgoalunit']}</span>
      //       <p>-</p>
      //     </div>
      //   )
      // } else {
      //   return (
      //     <div>
      //       <span className="small">{word['addtask_kpi_title_taskgoalunit']}</span>
      //       <p>
      //         {<FormatNumber num={item.sprintflow_goal} />} {item.unit_type_name}
      //       </p>
      //     </div>
      //   )
      // }
      return (
        <div>
          <span className="small">{word['addtask_kpi_title_taskgoalunit']}</span>
          <p>
            {<FormatNumber num={item.sprintflow_goal} />} {item.unit_type_name}
          </p>
        </div>
      )
    }
  }

  const checkInputTypeProject = (inputType, item) => {
    if (inputType == 22) {
      return (
        <div>
          <span className="small">{word['addtask_kpi_title_projectgoalminmax']}</span>
          <p>
            <FormatMinMax num={item.min} /> - <FormatMinMax num={item.max} />{' '}
            {item.unit_type_name}
          </p>
        </div>
      )
    } else {
      return (
        <div>
          <span className="small">{word['addtask_kpi_title_projectgoalunit']}</span>
          <p>
            {<FormatNumber num={item.goal} />} {item.unit_type_name}
          </p>
        </div>
      )
    }
  }

  const checkShowInputTypeTaskTask = (inputType, item) => {
    if (inputType == 22) {
      // if ((item.min == 0) & (item.max == 0)) {
      //   return (
      //     <div>
      //       <span className="small">{word['addtask_kpi_title_taskgoalminmax']}</span>
      //       <p>-</p>
      //     </div>
      //   )
      // }
      return (
        <div>
          <span className="small">{word['addtask_kpi_title_taskgoalminmax']}</span>
          <p>
            <FormatMinMax num={item.min} /> - <FormatMinMax num={item.max} />{' '}
            {item.unit_type_name}
          </p>
        </div>
      )
    } else {
      // if (item.goal == 0) {
      //   return (
      //     <div>
      //       <span className="small">{word['addtask_kpi_title_taskgoalunit']}</span>
      //       <p>-</p>
      //     </div>
      //   )
      // } else {
      return (
        <div>
          <span className="small">{word['addtask_kpi_title_taskgoalunit']}</span>
          <p>
            {<FormatNumber num={item.goal} />} {item.unit_type_name}
          </p>
        </div>
      )
    }
    //}
  }

  const checkShowRemaining = (inputtype, item) => {
    if (inputtype == 22) {
      return <p>-</p>
    } else {
      let realusegoal = ''
      if (item.sprintflow_id == 0) {
        //project
        realusegoal = item.usegoal
      } else {
        //task
        realusegoal = item.sprintflow_usegoal
      }
      return (
        <p>
          <FormatNumber num={item.goal - realusegoal} /> {item.unit_type_name}
        </p>
      )
    }
  }

  const showProject = () => {
    return (
      <div>
        <Header className="header">
          <h2>{word['addtask_kpi_title_projectkpi']}</h2>
        </Header>
        <SubContainer className="sub-container2">
          <ContainerCard className="containerCard">
            {dataKPIFinance &&
              dataKPIFinance.map((item) => {
                return (
                  <CardItem className="card">
                    <LeftCard className="left-card">
                      <div>
                        <span className="small">
                          {word['addtask_kpi_title_kpifinance']}
                        </span>
                        <p>{item.name}</p>
                      </div>

                      <Row className="KPITypeProjectGoal">
                        <div className="KPIType">
                          <span className="small">
                            {word['addtask_kpi_title_kpitype']}
                          </span>
                          <p>{item.kpi_type_name_en}</p>
                        </div>
                        <div className="ProjectGoal">
                          {checkInputTypeProject(item.input_type_id, item)}
                        </div>
                      </Row>

                      <Row>
                        <div className="KPIType">
                          <span className="small">
                            {word['addtask_kpi_title_remaining']}
                          </span>
                          {checkShowRemaining(item.input_type_id, item)}
                        </div>
                        <div
                          className="ProjectGoal"
                          style={{ display: 'flex', justifyContent: 'space-between' }}
                        >
                          {checkShowInputTypeTask(item.input_type_id, item)}
                          <a
                            style={{
                              display: 'flex',
                              alignItems: 'flex-end',
                            }}
                            hidden={role}
                          >
                            <EditOutlined
                              id="edit"
                              style={{ color: '#7C7C84' }}
                              onClick={() =>
                                checkInputTypeShowmodal(item.input_type_id, item)
                              }
                            // onClick={() => setVisableModalTaskGoals(true)}
                            />
                          </a>
                        </div>
                      </Row>
                    </LeftCard>
                  </CardItem>
                )
              })}
          </ContainerCard>
        </SubContainer>
      </div>
    )
  }

  const showTask = () => {
    return (
      <div>
        <Header className="header">
          <h2>{word['addtask_kpi_title_taskkpi']}</h2>
          <Button
            hidden={role}
            className="BTN_Next"
            onClick={() => onClickShowModal('add')}
            icon={<PlusOutlined className="Icon-color" />}
          >
            {word['addtask_kpi_btn_addtaskkpi']}
          </Button>
        </Header>
        <SubContainer className="sub-container2">
          <ContainerCard className="containerCard">
            {dataTask &&
              dataTask.map((item) => {
                return (
                  <CardItem className="card">
                    <LeftCard className="left-card">
                      <span className="small">
                        {word['addtask_kpi_title_kpifinance']}
                      </span>
                      <p>{item.name}</p>
                      <Row>
                        <div>
                          <span className="small">
                            {word['addtask_kpi_title_kpitype']}
                          </span>
                          <p>{item.kpi_type_name_en}</p>
                        </div>
                      </Row>
                      <Row style={{ width: '100%' }}>
                        <Col className="KPIType2">
                          {checkShowInputTypeTaskTask(item.input_type_id, item)}
                        </Col>
                        <Col
                        // className="ProjectGoal2"
                        // style={{ marginLeft: 80 }}
                        >
                          <div>
                            <span className="small">
                              {word['addtask_kpi_title_remaining']}
                            </span>
                          </div>
                          <div>{checkShowRemaining(item.input_type_id, item)}</div>
                        </Col>
                      </Row>
                    </LeftCard>
                    <RightCard className="right-card">
                      <div hidden={role} className={role ? 'active-showmore' : ''}>
                        <Dropdown
                          overlay={() => menu(item)}
                          trigger={['click']}
                          placement="bottomRight"
                        >
                          <a
                          // onClick={(e) => e.preventDefault()}
                          >
                            <img src={more} />
                          </a>
                        </Dropdown>
                      </div>
                    </RightCard>
                  </CardItem>
                )
              })}
          </ContainerCard>
        </SubContainer>
      </div>
    )
  }

  const emptyProject = () => {
    return (
      <ConatainerKPI className="containerKPI-Task">
        {/* {btnStatus()} */}
        <Header className="header">
          <h2>{word['addtask_kpi_title_emptyproject']}</h2>
        </Header>
        <SubContainer className="sub-container">
          <EmptyState className="empty-kpi">
            <img src={emptyKPI} />
            <h2 style={{ marginTop: 20 }}>{word['addtask_kpi_title_emptystate']}</h2>
            {/* <Button
        className="BTN_ClassA"
        onClick={() => onClickShowModal('add')}
        icon={<PlusOutlined className="Icon-color" />}
      >
        Add New Task KPI/Finance
      </Button> */}
          </EmptyState>
          {/* {footer()} */}
        </SubContainer>
      </ConatainerKPI>
    )
  }

  const emptyTask = () => {
    return (
      <ConatainerKPI className="containerKPI-Task">
        {/* {btnStatus()} */}
        <Header className="header">
          <h2>{word['addtask_kpi_title_emptytask']}</h2>
          <Button
            id="AddNewTaskKPI/Finance"
            className="BTN_Next"
            onClick={() => onClickShowModal('add')}
            hidden={role}
            icon={<PlusOutlined className="Icon-color" />}
          >
            {word['addtask_kpi_btn_addnewtaskkpi']}
          </Button>
        </Header>
        <SubContainer className="sub-container">
          <EmptyState className="empty-kpi">
            <img src={emptyKPI} />
            <h2 style={{ marginTop: 20 }}>{word['addtask_kpi_title_emptystate']}</h2>
          </EmptyState>
          {/* {footer()} */}
        </SubContainer>
      </ConatainerKPI>
    )
  }

  if (canKPIFinance == false) {
    return <NoPermission />
  } else if (render === '1' && render2 == '') {
    return (
      <Container>
        <ConatainerKPI className="containerKPI-Task">
          {showProject()} {emptyTask()}
        </ConatainerKPI>
        {showModal()}
      </Container>
    )
  } else if (render === '' && render2 == '1') {
    return (
      <Container>
        <ConatainerKPI className="containerKPI-Task">
          {emptyProject()} {showTask()}
        </ConatainerKPI>
        {showModal()}
      </Container>
    )
  } else if (render === '1' && render2 == '1') {
    return (
      <Container>
        <ConatainerKPI className="containerKPI-Task">
          {showProject()} {showTask()}
        </ConatainerKPI>
        {showModal()}
      </Container>
    )
  } else {
    return (
      <Container>
        {emptyProject()}
        {emptyTask()}
        {showModal()}
      </Container>
    )
  }
}
export default AddTaskKPIFinance
